/** W81 B5 (Nachtrag D-433 Punkt 4, Auflage A3): das Blatt zur neuen Fassung der Einwilligung in „Alle meine Briefe“ kommt
 *  hoechstens einmal je Sitzung. Wie bei der neuen Fassung (fassung.ts) und dem Hinweis zur Nutzungsstatistik
 *  (nutzungHinweis.ts) nur im Speicher: neu laden oder neu anmelden zeigt es wieder, solange der Server die Marke haelt. */
let gefragt = false;

/** Text ueber dem Blatt und in den Einstellungen, wortgleich in iOS und Android. */
export const RUECKFALL_SATZ = "Der Text der Einwilligung hat sich geändert. Bis du neu zustimmst, entscheidest du bei einzelnen Briefen.";

export function rueckfallGefragt(): boolean {
  return gefragt;
}

export function rueckfallMerken(): void {
  gefragt = true;
}

/** Bei einer neuen Anmeldung darf das Blatt wieder kommen. */
export function rueckfallZuruecksetzen(): void {
  gefragt = false;
}
